import { Ref } from "vue";

export interface States {
    loadingShow: Ref<boolean>;
    errorMessage: Ref<string>;
    captchaEnabled: boolean;
    recaptcha: any;
}

export function submitHandler<T = void>(
    actionPromise: Promise<T>,
    states: States,
    successHandler?: (response: any) => any,
    errorHandler?: (err: Error) => void
): Promise<void> {
    states.errorMessage.value = "";
    if (states.captchaEnabled && !states.recaptcha?.value?.token()) {
        states.errorMessage.value = "Please complete captcha to proceed";
        return Promise.resolve();
    }

    states.loadingShow.value = true;
    return actionPromise
        .then(successHandler ? successHandler : () => { })
        .catch(errorHandler ? errorHandler : (err: Error) => {
            states.recaptcha?.value?.reset();
            states.errorMessage.value = err.message;
        })
        .then(() => {
            states.loadingShow.value = false;
        })
        .catch((err: Error) => console.error(err));
}